//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CommonClassifier from '@/components/nav_common/CommonClassifier'
import { Author, Collection } from '@/models'

export default {
  data () {
    return {
      contents: [
        /* {
          title: '分类',
          classList: [
            "唐诗三百",
            "古诗三百",
            "宋词三百",
            "宋词精选",
            "古诗十九",
            "诗经",
            "楚辞",
            "乐府",
            "小学古诗",
            "小学文言",
            "初中古诗",
            "初中文言",
            "高中古诗",
            "高中文言",
            "写景",
            "咏物",
            "春天",
            "夏天",
            "秋天",
            "冬天",
            "写雨",
            "写雪",
            "写风",
            "写花",
            "梅花",
            "荷花",
            "菊花",
            "柳树",
            "月亮",
            "山水",
            "写山",
            "写水",
            "长江",
            "黄河",
            "儿童",
            "写鸟",
            "写马",
            "田园",
            "边塞",
            "地名",
            "节日",
            "春节",
            "元宵",
            "寒食",
            "清明",
            "端午",
            "七夕",
            "中秋",
            "重阳",
            "怀古",
            "抒情",
            "爱国",
            "离别",
            "送别",
            "思乡",
            "思念",
            "爱情",
            "励志",
            "哲理",
            "闺怨",
            "悼亡",
            "写人",
            "老师",
            "母亲",
            "友情",
            "战争",
            "读书",
            "惜时",
            "忧民",
            "婉约",
            "豪放",
            "民谣",
            "词牌大全",
            "古文观止",
          ]
        },
        {
          title: '类型',
          classList: [
            "诗",
            "词",
            "曲",
            "文言文",
          ]
        } */
      ]
    }
  },
  components: {
    CommonClassifier
  },
  beforeCreate () {
    Author.getHotAuthorsByLikers(1, 30).then(result => {
      let content = { title: '作者', routePrev: '/author/'}

      content.classList = result.map(item => {
        return {
          id: item.id,
          text: item.get('name')
        }
      })

      this.contents.unshift(content)
    })

    Collection.getCollections().then(result => {
      let content = { title: '分类', routePrev: '/collection/'}

      content.classList = result.map(item => {
        return {
          id: item.id,
          text: item.get('name')
        }
      })

      this.contents.unshift(content)
    })
  },
  methods: {
    goToAuthor (item) {
      this.$router.push({
        name: 'author',
        params: {
          id: item.id
        }
      })
    },

    goToCollection (item) {
      this.$router.push({
        name: 'collection',
        params: {
          id: item.id
        }
      })
    },
    chooseNavgate (item, title) {
      switch (title) {
        case '作者':
          this.goToAuthor(item)
          break
        case '分类':
          this.goToCollection(item)
          break
        // case '体裁': 
        //   this.break
        // case '朝代': break
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/nav_quote/QuoteRight.vue